export default {"src":"/_next/static/media/star_grey.fb710d9c.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};